import React, { useState, useEffect } from 'react';
import { generateColorFromId, formatLabel, sanitizeModeName } from '../../utils/modeScheduleUtils';

function DayScheduleTimelineDisplay({ modes, schedule }) {
    const modeMap = modes.reduce((acc, mode) => {
        acc[mode.id] = mode.name;
        return acc;
    }, {});
    const blocksData = schedule?.configs.map(config => ({
        mode: config.mode,
        label: modeMap[config.mode] || 'idle',
        start: config.from_slot / 4,
        end: config.to_slot / 4,
        config: config.config,
    }));
    const visibleBlocks = blocksData.filter(b => b.label !== 'idle');

    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date());
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    const PIXELS_PER_HOUR = 64;

    const toTimeString = hourFloat => {
        const hour = Math.floor(hourFloat);
        const minutes = Math.round((hourFloat - hour) * 60);
        return `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    };

    const currentHour = currentTime.getUTCHours() + currentTime.getUTCMinutes() / 60;

    return (
        <div className="timeline">
            <div className="timeline__track">
                <div className="timeline__hours">
                    {[...Array(25)].map((_, hour) => (
                        <div key={hour} className="timeline__hour">
                            {hour}:00
                        </div>
                    ))}
                </div>
                <div className="timeline__lines-container">
                    {[...Array(24 * 4 + 1)].map((_, i) => {
                        const leftPos = i * (PIXELS_PER_HOUR * 0.25);
                        return <div key={i} className="timeline__subdivision" style={{ left: `${leftPos}px` }} />;
                    })}
                </div>
                <div className="timeline__blocks">
                    {visibleBlocks.map((block, index) => {
                        const width = (block.end - block.start) * PIXELS_PER_HOUR;
                        const left = block.start * PIXELS_PER_HOUR;
                        return (
                            <div
                                key={index}
                                className="timeline__block"
                                style={{
                                    width: `${width}px`,
                                    left: `${left}px`,
                                    backgroundColor: generateColorFromId(sanitizeModeName(block.label)),
                                }}
                                title={`${toTimeString(block.start)} - ${toTimeString(block.end)}`}
                            >
                                {formatLabel(block.label)}
                            </div>
                        );
                    })}
                    <div className="timeline__marker" style={{ left: `${currentHour * PIXELS_PER_HOUR}px` }}>
                        <div className="timeline__marker-label">Active</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DayScheduleTimelineDisplay;
